import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Wallet } from './wallet.types';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class WithdrawLimitsService {
    private api: string = environment.api;
    private selectedWalletSubject = new BehaviorSubject<any>(null);
    selectedWallet$ = this.selectedWalletSubject.asObservable();
    private _isAddPaymentUnitSelected = new BehaviorSubject<boolean>(true);
    private _paymentUnits = new BehaviorSubject<any>(null);

    constructor(private httpclient: HttpClient) {}

    get paymentUnits$() {
        return this._paymentUnits.asObservable();
    }

    get isAddPaymentUnitSelected$() {
        return this._isAddPaymentUnitSelected.asObservable();
    }

    selectedWallet(wallet: Wallet) {
        this.selectedWalletSubject.next(wallet);
    }

    setIsAddPaymentUnitSelected(value: boolean) {
        this._isAddPaymentUnitSelected.next(value);
    }

    getAllAliases(): Observable<string[]> {
        return this.httpclient
            .get<string[]>(`${this.api}/withdraw-limits/alias`)
            .pipe(
                catchError((error) => {
                    console.error('Error fetching aliases:', error);
                    return [];
                })
            );
    }

    getPaymentUnits(): Observable<Wallet[]> {
        return this.httpclient
            .get<Wallet[]>(`${this.api}/withdraw-limits/limits`)
            .pipe(
                tap((wallets) => {
                    this._paymentUnits.next(wallets);
                }),
                catchError((error) => {
                    console.error('Error fetching payment units:', error);
                    return of([]);
                })
            );
    }

    getLimitsByPU(name: string) {
        return this.httpclient
            .get(`${this.api}/withdraw-limits/limits/${name}`)
            .pipe(
                catchError((error) => {
                    console.error('Error fetching payment unit:', error);
                    throw error;
                })
            );
    }

    saveLimitChanges(wallet: Wallet) {
        return this.httpclient
            .post(`${this.api}/withdraw-limits/set-limits`, wallet)
            .pipe(
                catchError((error: any): any => {
                    throw new Error(error.message);
                })
            );
    }

    saveAlias(alias: any) {
        return this.httpclient
            .post(`${this.api}/withdraw-limits/set-collections`, alias)
            .pipe(
                catchError((error: any): any => {
                    throw new Error(error.message);
                })
            );
    }

    deletePaymentUnit(wallet: Wallet) {
        return this.httpclient
            .post(`${this.api}/withdraw-limits/delete-limits`, wallet)
            .pipe(
                catchError((error: any): any => {
                    throw new Error(error.message);
                })
            );
    }
    creditToAvailableBalance(data: any) {
        return this.httpclient
            .post(`${this.api}/withdraw-limits/credit`, data)
            .pipe(
                catchError((error: any): any => {
                    throw new Error(error.message);
                })
            );
    }
    debitToAvailableBalance(data: any) {
        return this.httpclient
            .post(`${this.api}/withdraw-limits/debit`, data)
            .pipe(
                catchError((error: any): any => {
                    throw new Error(error.message);
                })
            );
    }
    refreshAvailableBalance(data: any) {
        return this.httpclient
            .post(`${this.api}/withdraw-limits/refresh`, data)
            .pipe(
                catchError((error: any): any => {
                    throw new Error(error.message);
                })
            );
    }
}
